import {
    HorizAlignment,
    ISearch, ISearchProfile, ISearchProvider, ISearchRequestSubset,
    SearchProviderFieldType, ISearchProviderField
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {PASearch} from "../PA.Core/PASearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";


const vUI_AppSuiteType_Search_Fields: {[id:string]: ISearchProviderField } = {
    WB_UI_APPSUITEM_ID:    {type: SearchProviderFieldType.number, renderOptions: { columnName: 'WBId', columnResourceName: 'colWBId', alignment: HorizAlignment.Right}, domainOptions: { maxLength: 50}},
    APPSUITETYPE_ID:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Id', columnResourceName: 'colId', alignment: HorizAlignment.Left}, domainOptions: {}},
    APPSUITETYPE_NAME:     {type: SearchProviderFieldType.string, renderOptions: { columnName: 'AppSuiteType Name', columnResourceName: 'colName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    SORT_ORDER:            {type: SearchProviderFieldType.number, renderOptions: { columnName: 'Sort', columnResourceName: 'colSort', alignment: HorizAlignment.Right, numberFormat: "#,##0", columnWidthCharacters: 10}, domainOptions: { maxLength: 50}},
}

const UIAppSuiteTypeSearchProviderBasic: ISearchProvider = {

    keyFields: {id:    'WB_UI_APPSUITEM_ID',
        id_ui: 'APPSUITETYPE_ID',
        name:  'APPSUITETYPE_NAME'},

    searchProviderFields: vUI_AppSuiteType_Search_Fields,

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vUI_AppSuiteType_Search',
                this.searchProviderFields,
                [])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                })
        })
    }

}

const UIAppSuiteTypeSearchAppSuiteTypeByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: { ui5ResourceId: "UIAppSuiteTypeSearchAppSuiteTypeByName" },

    profileFilter: [
        {profileFilterName: 'Id',     searchProviderFieldId: 'APPSUITETYPE_ID', renderOptions: { }},
        {profileFilterName: 'Name',   searchProviderFieldId: 'APPSUITETYPE_NAME', renderOptions: { }}
    ],  // ISearchFields
    profileDisplayFields: [
        'APPSUITETYPE_ID','APPSUITETYPE_NAME','SORT_ORDER'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: UIAppSuiteTypeSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}


const UIAppSuiteTypeSearch: ISearch = {
    searchName: "Find App Suite Type",
    renderOptions: { ui5ResourceId: "UIAppSuiteTypeSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [UIAppSuiteTypeSearchAppSuiteTypeByName]
}

PAEnvironment.registerBusinessObjectSearch("UIAppSuiteTypeBO", "AppSuiteType", UIAppSuiteTypeSearch, "App Suite Type Search")

export {UIAppSuiteTypeSearch}